/**
 * LandingPage — the StudySync landing page (served at "/"), rebuilt with ONLY real
 * RetroUI components + Tailwind (ZERO @mui/*).
 *
 * This route renders standalone (no MUI theme wrapper), so it
 * self-imports the self-hosted fonts and the landing-scoped RetroUI stylesheet
 * (`retroui.css`) — the latter pulls in Tailwind's layers + RetroUI :root tokens
 * so every utility class (bg-primary, font-head, shadow-md, …) resolves here.
 *
 * The page itself is composed in ./sections/RetroLanding.
 */

// Self-hosted fonts: Archivo Black headings, Space Grotesk body, Space Mono mono.
import '@fontsource/archivo-black/400.css';
import '@fontsource/space-grotesk/400.css';
import '@fontsource/space-grotesk/500.css';
import '@fontsource/space-grotesk/700.css';
import '@fontsource/space-mono/400.css';
import '@fontsource/space-mono/700.css';

// Landing-scoped RetroUI stylesheet: Tailwind layers (Preflight OFF) + RetroUI
// :root tokens. Required here so Tailwind utilities resolve on this standalone route.
import './retroui.css';

import * as React from 'react';
import RetroLanding from './sections/RetroLanding';

const LandingPage: React.FC = () => <RetroLanding />;

export default LandingPage;
